import { HYDRATE, HydrateAction } from "redux/reducers/hydration";

type ConfigState = {
  domainCountryCode: string;
};

export const initialState: ConfigState = { domainCountryCode: "US" };

// This is a special action that any reducer can respond to, similar to load cookies
export const SET_DOMAIN_LOCATION = "config/domain/set";

export type SetDomainCountryCodeAction = {
  type: typeof SET_DOMAIN_LOCATION;
  countryCode: string;
};

export type ConfigActions = SetDomainCountryCodeAction | HydrateAction;

const configReducer = (
  state = initialState,
  action: ConfigActions,
): ConfigState => {
  switch (action.type) {
    case HYDRATE:
      /**
       * Ignore any hydration events after initial page load to preserve any
       * subsequent changes that have been made on the client.
       */
      return state;
    case SET_DOMAIN_LOCATION:
      return {
        ...state,
        domainCountryCode: action.countryCode,
      };
    default:
      return state;
  }
};

export default configReducer;
